import React from 'react'
import { Outlet } from 'react-router-dom'
import Navbar from './Header'
import Footer from './Footer'
import FloatingWhatsApp from '../Pages/WhatsApp/FloatingWhatsApp'
import CookieConsentBanner from '../Components/Cookies/CookieConsentBanner'

const Layouts = () => {
  return (
    <div>
        <Navbar/>
        <Outlet/>
        <FloatingWhatsApp />
        <CookieConsentBanner />
        <Footer/>
    </div>
  )
}

export default Layouts